import React, {useCallback, useEffect, useMemo} from "react";
import {v4 as uuidV4} from "uuid";
import {AdvancedMarker, useAdvancedMarkerRef} from "@vis.gl/react-google-maps";
import AddLocationAltIcon from '@mui/icons-material/AddLocationAlt';
import PropertyModel from "api/model/PropertyModel";
import {MarkerInfo} from "components/Search/SearchMap";
import {MarkerModel} from "components/Search/PopupSearch/PopupMapMarkerClusterer";
import PopupMapComingSoonInfo from "components/Search/PopupSearch/PopupMapComingSoonInfo";
import "./styles.css";

interface PopupMarkerProps {
    showInfo: (markerInfo: MarkerInfo) => void,
    property: PropertyModel,
    setRef: (ref: MarkerModel) => void,
    removeRef: (id: string) => void,
}

const PopupMapComingSoonMarker = (props: PopupMarkerProps) => {
    const {
        setRef,
        showInfo,
        property,
        removeRef,
    } = props;
    const [markerRef, marker] = useAdvancedMarkerRef();
    const id = useMemo(() => {
        return uuidV4();
    }, []);
    const handleMarkerClick = useCallback(() => marker && showInfo({
        marker,
        title: (
            <h2 className="popup-search-coming-soon__marker--info-title">
                <AddLocationAltIcon fontSize="medium" color="primary"/>{property.name}
            </h2>
        ),
        content: (<PopupMapComingSoonInfo/>),
    }), [marker]);
    useEffect(() => {
        if (marker) {
            setRef({
                id,
                marker,
                count: 1
            });
            return () => removeRef(id);
        }
    }, [marker]);
    return (
        <>
            <AdvancedMarker
                ref={markerRef}
                position={property.location}
                title={property.name}
                onClick={handleMarkerClick}
            >
                <div className="popup-search-coming-soon__marker">
                    <AddLocationAltIcon fontSize="small" color="secondary"/>
                </div>
            </AdvancedMarker>
        </>
    )
}

export default PopupMapComingSoonMarker;
